import { CheckMarkIcon } from '@/common/icons/arrows.tsx'
import { cn } from '@/common/utilities.ts'
import { ApplicationStep } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'

type ApplicationStepperProps = {
  currentStep: number
  readonly steps: ApplicationStep[]
  className?: string
}
const ApplicationStepper = ({
  currentStep,
  steps,
  className,
}: ApplicationStepperProps) => {
  return (
    <>
      <nav aria-label="Progress" className={className}>
        <ol
          role="list"
          className="overflow-hidden flex space-x-6 p-4 almost_lg:space-x-8"
        >
          {steps.map((step) => (
            <li key={step.name} className="relative flex items-center">
              {step.id !== steps.length - 1 && (
                <div
                  aria-hidden="true"
                  className={cn(
                    'hidden absolute top-1/2 left-full h-0.5 w-6 bg-gray-900 transform ml-2 almost_lg:block',
                    { 'opacity-50': step.id < currentStep }
                  )}
                />
              )}
              <span className="group relative flex items-center">
                <span className="flex items-center justify-center">
                  {step.id < currentStep ? (
                    <span className="ml-2 relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-green-700 text-white opacity-50">
                      <CheckMarkIcon className="text-lg" />
                    </span>
                  ) : (
                    <span
                      className={cn(
                        'ml-2 relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2',
                        step.id === currentStep
                          ? 'border-green-600'
                          : 'border-gray-500 text-gray-500'
                      )}
                    >
                      <span>{step.id + 1}</span>
                    </span>
                  )}
                </span>
                <span
                  className={cn(
                    'ml-2 text-sm font-medium',
                    step.id < currentStep
                      ? 'text-gray-900 opacity-50'
                      : 'text-gray-500'
                  )}
                >
                  {step.name}
                </span>
              </span>
            </li>
          ))}
        </ol>
      </nav>
    </>
  )
}

export default ApplicationStepper
